<template>
  <PressReleaseModule
    :module-data="document"
    data-luko-tracking="Page-Press-Release_slug"
  />
</template>

<script>
import PressReleaseModule from '~/modules/PressRelease'
import { formatMetaDatas } from '~/utils/metaData'

export default {
  head() {
    const { article_title, article_introduction, article_illustration } =
      this.document

    const defaultMeta = {
      twitter_title: article_title[0].text,
      twitter_description: article_introduction[0].text,
      twitter_image: article_illustration.url,
    }
    return formatMetaDatas(this.metaDatas, this.$route.path, defaultMeta)
  },

  components: {
    PressReleaseModule,
  },

  async asyncData({ app, $prismic, store, params, error }) {
    try {
      const { data: document, alternate_languages } =
        await $prismic.api.getByUID('press_release', params.slug, {
          lang: app.i18n.localeProperties.prismicIso,
        })

      store.dispatch('setAlternateLanguages', alternate_languages)
      store.commit('page/UPDATE', {
        theme: '2021Q4-pink',
      })

      return {
        document,
        metaDatas: document.body1 || [],
      }
    } catch (e) {
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>

<style></style>
